module.exports = __webpack_public_path__ + "images/design/desktop/header_logo_mobile.png";